import { ComponentLoader } from '@bythepixel/component-loader';
import BuildTrailerLink from './buildTrailerLink';
import OptionSelector from './optionSelector';
import SelectedColorOutput from './selectedColorOutput';
import TrailerAnimation from '../components/trailerAnimation';

window.trailerComponents = new ComponentLoader(document, [
  BuildTrailerLink,
  OptionSelector,
  SelectedColorOutput,
  TrailerAnimation,
]);
